/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
import './notifications';
import '../common/client';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "agenda": {
        "nested": {
          "CreateMerchantFeedbackRequest": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "currentUnit": {
                "type": ".squareup.agenda.UnitIdentifier",
                "id": 2,
                "rule": "optional"
              },
              "feedback": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "rating": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              },
              "installationIdentity": {
                "type": ".squareup.agenda.ClientInstallationIdentity",
                "id": 5,
                "rule": "optional"
              },
              "timestamp": {
                "type": ".squareup.common.time.DateTime",
                "id": 6,
                "rule": "optional"
              }
            }
          },
          "ActivityFeedItem": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "category": {
                "type": ".squareup.agenda.ActivityFeedItem.Category",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": "GENERAL"
                }
              },
              "messages": {
                "type": ".squareup.agenda.AtrributedMessage",
                "id": 5,
                "rule": "repeated"
              },
              "actionPayloads": {
                "type": ".squareup.agenda.ActionPayload",
                "id": 6,
                "rule": "repeated"
              },
              "createdAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 7,
                "rule": "optional"
              },
              "icon": {
                "type": ".squareup.agenda.ActivityFeedIcon",
                "id": 3
              },
              "imageUrl": {
                "type": "string",
                "id": 4
              }
            },
            "nested": {
              "Category": {
                "values": {
                  "GENERAL": 0,
                  "PENDING_REQUESTS": 1,
                  "INFORMATION": 3
                }
              },
              "image": {
                "oneof": ["icon", "imageUrl"]
              }
            }
          },
          "ActivityFeedIcon": {
            "fields": {
              "style": {
                "type": ".squareup.agenda.ActivityFeedIcon.ActivityFeedIconStyle",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": "NORMAL"
                }
              },
              "dayOfMonth": {
                "type": "uint32",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "ActivityFeedIconStyle": {
                "values": {
                  "NORMAL": 0,
                  "ACCEPTED": 1,
                  "DECLINED": 2,
                  "CANCELED": 3,
                  "MARK_NO_SHOW": 4
                }
              }
            }
          },
          "AttributeInfo": {
            "fields": {
              "style": {
                "type": ".squareup.agenda.AttributeInfo.Style",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": "NORMAL"
                }
              },
              "range": {
                "type": ".squareup.agenda.AttributeInfo.Range",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Style": {
                "values": {
                  "NORMAL": 1,
                  "SECTION_LABEL": 0,
                  "BOLD": 2,
                  "STRIKETHROUGH": 3,
                  "DESTRUCTIVE_STRIKETHROUGH": 4,
                  "NEW_FEATURE": 6
                }
              },
              "Range": {
                "fields": {
                  "start": {
                    "type": "uint32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "length": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "AtrributedMessage": {
            "fields": {
              "text": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "attributes": {
                "type": ".squareup.agenda.AttributeInfo",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "ListActivityFeedRequest": {
            "fields": {
              "currentUnit": {
                "type": ".squareup.agenda.UnitIdentifier",
                "id": 1,
                "rule": "optional"
              },
              "lastNotificationId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "limit": {
                "type": "int64",
                "id": 3,
                "rule": "optional",
                "options": {
                  "default": 10
                }
              }
            }
          },
          "ListActivityFeedResponse": {
            "fields": {
              "items": {
                "type": ".squareup.agenda.ActivityFeedItem",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "ReferralLink": {
            "fields": {
              "url": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "ReferralTexts": {
            "fields": {
              "referralTitle": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "referralSteps": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              },
              "referralDescription": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "UnitIdentifier": {
            "fields": {
              "personToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "ClientInstallationIdentity": {
            "fields": {
              "product": {
                "type": ".squareup.common.client.Product",
                "id": 2,
                "rule": "optional"
              },
              "device": {
                "type": ".squareup.common.client.Device",
                "id": 3,
                "rule": "optional"
              },
              "fullyQualifiedApplicationIdentifier": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "NotificationButton": {
            "fields": {
              "title": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "action": {
                "type": ".squareup.agenda.NotificationButton.ActionType",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": "DISMISS"
                }
              },
              "url": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            },
            "nested": {
              "ActionType": {
                "values": {
                  "DISMISS": 1,
                  "OPEN_URL": 2
                }
              }
            }
          },
          "CheckApplicationNotification": {
            "fields": {
              "title": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "message": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "canBeDismissed": {
                "type": "bool",
                "id": 3,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "cancelButton": {
                "type": ".squareup.agenda.NotificationButton",
                "id": 4,
                "rule": "optional"
              },
              "button": {
                "type": ".squareup.agenda.NotificationButton",
                "id": 5,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.agenda?.nested?.CreateMerchantFeedbackRequest && !$root.nested?.squareup?.nested?.agenda?.nested?.ActivityFeedItem && !$root.nested?.squareup?.nested?.agenda?.nested?.ActivityFeedItem?.nested?.Category && !$root.nested?.squareup?.nested?.agenda?.nested?.ActivityFeedIcon && !$root.nested?.squareup?.nested?.agenda?.nested?.ActivityFeedIcon?.nested?.ActivityFeedIconStyle && !$root.nested?.squareup?.nested?.agenda?.nested?.AttributeInfo && !$root.nested?.squareup?.nested?.agenda?.nested?.AttributeInfo?.nested?.Style && !$root.nested?.squareup?.nested?.agenda?.nested?.AttributeInfo?.nested?.Range && !$root.nested?.squareup?.nested?.agenda?.nested?.AtrributedMessage && !$root.nested?.squareup?.nested?.agenda?.nested?.ListActivityFeedRequest && !$root.nested?.squareup?.nested?.agenda?.nested?.ListActivityFeedResponse && !$root.nested?.squareup?.nested?.agenda?.nested?.ReferralLink && !$root.nested?.squareup?.nested?.agenda?.nested?.ReferralTexts && !$root.nested?.squareup?.nested?.agenda?.nested?.UnitIdentifier && !$root.nested?.squareup?.nested?.agenda?.nested?.ClientInstallationIdentity && !$root.nested?.squareup?.nested?.agenda?.nested?.NotificationButton && !$root.nested?.squareup?.nested?.agenda?.nested?.NotificationButton?.nested?.ActionType && !$root.nested?.squareup?.nested?.agenda?.nested?.CheckApplicationNotification) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateMerchantFeedbackRequest @ squareup/agenda/agenda.proto at 26:1
 */
export const CreateMerchantFeedbackRequest = $root.lookupType('squareup.agenda.CreateMerchantFeedbackRequest');
fixType(CreateMerchantFeedbackRequest, {
  id: {
    notEmpty: true
  },
  currentUnit: {
    required: true
  },
  installationIdentity: {
    required: true
  }
});
Builder.createAndAttachToType(CreateMerchantFeedbackRequest);
/**
 * A ActivityFeedItem displays an image, some text and optionally some actions.
 *
 * SOURCE ActivityFeedItem @ squareup/agenda/agenda.proto at 105:1
 */
export const ActivityFeedItem = $root.lookupType('squareup.agenda.ActivityFeedItem');
fixType(ActivityFeedItem, {
  id: {
    required: true
  }
});
Builder.createAndAttachToType(ActivityFeedItem);
/**
 * SOURCE Category @ squareup/agenda/agenda.proto at 106:3
 */
ActivityFeedItem.Category = $root.lookupEnum('squareup.agenda.ActivityFeedItem.Category').values;
/**
 * SOURCE ActivityFeedIcon @ squareup/agenda/agenda.proto at 141:1
 */
export const ActivityFeedIcon = $root.lookupType('squareup.agenda.ActivityFeedIcon');
fixType(ActivityFeedIcon, {
  style: {
    required: true
  }
});
Builder.createAndAttachToType(ActivityFeedIcon);
/**
 * SOURCE ActivityFeedIconStyle @ squareup/agenda/agenda.proto at 142:5
 */
ActivityFeedIcon.ActivityFeedIconStyle = $root.lookupEnum('squareup.agenda.ActivityFeedIcon.ActivityFeedIconStyle').values;
/**
 * The type of styling to apply and where to apply it.
 *
 * SOURCE AttributeInfo @ squareup/agenda/agenda.proto at 157:1
 */
export const AttributeInfo = $root.lookupType('squareup.agenda.AttributeInfo');
fixType(AttributeInfo, {
  style: {
    required: true
  },
  range: {
    required: true
  }
});
Builder.createAndAttachToType(AttributeInfo);
/**
 * SOURCE Style @ squareup/agenda/agenda.proto at 158:3
 */
AttributeInfo.Style = $root.lookupEnum('squareup.agenda.AttributeInfo.Style').values;
/**
 * SOURCE Range @ squareup/agenda/agenda.proto at 178:3
 */
AttributeInfo.Range = $root.lookupType('squareup.agenda.AttributeInfo.Range');
fixType(AttributeInfo.Range, {
  start: {
    required: true
  },
  length: {
    required: true
  }
});
Builder.createAndAttachToType(AttributeInfo.Range);
/**
 * A grouping of text (including new-lines) that can contain various styling guidelines.
 * Each logical section of text should be it's own message:
 * * On a pending appt, the title should be separate from the date section.
 * * On pending appts there shoud be a message for the request and one for the date & services.
 *
 * SOURCE AtrributedMessage @ squareup/agenda/agenda.proto at 194:1
 */
export const AtrributedMessage = $root.lookupType('squareup.agenda.AtrributedMessage');
fixType(AtrributedMessage, {
  text: {
    required: true
  }
});
Builder.createAndAttachToType(AtrributedMessage);
/**
 * SOURCE ListActivityFeedRequest @ squareup/agenda/agenda.proto at 200:1
 */
export const ListActivityFeedRequest = $root.lookupType('squareup.agenda.ListActivityFeedRequest');
fixType(ListActivityFeedRequest, {
  currentUnit: {
    required: true
  }
});
Builder.createAndAttachToType(ListActivityFeedRequest);
/**
 * SOURCE ListActivityFeedResponse @ squareup/agenda/agenda.proto at 211:1
 */
export const ListActivityFeedResponse = $root.lookupType('squareup.agenda.ListActivityFeedResponse');
fixType(ListActivityFeedResponse);
Builder.createAndAttachToType(ListActivityFeedResponse);
/**
 * SOURCE ReferralLink @ squareup/agenda/agenda.proto at 215:1
 */
export const ReferralLink = $root.lookupType('squareup.agenda.ReferralLink');
fixType(ReferralLink);
Builder.createAndAttachToType(ReferralLink);
/**
 * SOURCE ReferralTexts @ squareup/agenda/agenda.proto at 219:1
 */
export const ReferralTexts = $root.lookupType('squareup.agenda.ReferralTexts');
fixType(ReferralTexts);
Builder.createAndAttachToType(ReferralTexts);
/**
 * We pass this with requests to identify who which unit/employment we're acting on behalf of.
 * By this being its own message, we can validate it easier
 * Even though employment token maps to merchant token, etc, it is easier to validate and debug
 * if all three are provided
 *
 * SOURCE UnitIdentifier @ squareup/agenda/agenda.proto at 370:1
 */
export const UnitIdentifier = $root.lookupType('squareup.agenda.UnitIdentifier');
fixType(UnitIdentifier, {
  personToken: {
    notEmpty: true
  },
  merchantToken: {
    notEmpty: true
  },
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UnitIdentifier);
/**
 * Contains information about the app and the device that are running.
 *
 * SOURCE ClientInstallationIdentity @ squareup/agenda/agenda.proto at 377:1
 */
export const ClientInstallationIdentity = $root.lookupType('squareup.agenda.ClientInstallationIdentity');
fixType(ClientInstallationIdentity, {
  product: {
    required: true
  },
  device: {
    required: true
  }
});
Builder.createAndAttachToType(ClientInstallationIdentity);
/**
 * SOURCE NotificationButton @ squareup/agenda/agenda.proto at 624:1
 */
export const NotificationButton = $root.lookupType('squareup.agenda.NotificationButton');
fixType(NotificationButton, {
  title: {
    required: true
  },
  action: {
    required: true
  }
});
Builder.createAndAttachToType(NotificationButton);
/**
 * SOURCE ActionType @ squareup/agenda/agenda.proto at 630:3
 */
NotificationButton.ActionType = $root.lookupEnum('squareup.agenda.NotificationButton.ActionType').values;
/**
 * SOURCE CheckApplicationNotification @ squareup/agenda/agenda.proto at 643:1
 */
export const CheckApplicationNotification = $root.lookupType('squareup.agenda.CheckApplicationNotification');
fixType(CheckApplicationNotification, {
  title: {
    required: true
  },
  message: {
    required: true
  },
  cancelButton: {
    required: true
  }
});
Builder.createAndAttachToType(CheckApplicationNotification);